
import _ from 'lodash'
import img from '../process/assets/icon.png'
import { UUID } from '@/plugins/common'
export default class AppReportModel {
  id = UUID.create()

  // 模块名称
  moduleName=''
  // 是否展示在工作台
  workbenchType = false
  // 图标
  appIcon = img

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    let appReportModel = new AppReportModel(args)
    return appReportModel
  }

  static load (args) {
    let appReportModel = new AppReportModel(args)
    appReportModel.appIcon = args.appIcon || img
    return appReportModel
  }
}



// WEBPACK FOOTER //
// ./src/store/report/appReportModel.js